// extracted by mini-css-extract-plugin
module.exports = {"styleTab":"_9u1v-_rvDLVFe9qHVWlK","footer":"_3ULXw_Af00VzIylTP2V5BC"};